let routes = [
    {
        path: '/',
        name: '付费阅读',
        component: ()=>import('../components/child_router_view'),
        children:[{
            path: '/reader-list',
            name: '阅读列表',
            component: () => import('../components/reader/list.vue')
          },
          {
            path: '/reader-section',
            name: '栏目管理',
            component: () => import('../components/reader/section.vue')
          },
          {
            path: '/reader-setting',
            name: '付费设置',
            component: () => import('../components/reader/setting.vue')
          },
          {
            path: '/add-article',
            name: '新建文章',
            component: () => import('../components/reader/new_article.vue')
          },
          {
            path: '/comment',
            name: '评论管理',
            component: () => import('../components/reader/comment.vue')
          },
          {
            path: '/reader-order',
            name: '阅读单篇订单',
            component: () => import('../components/reader/order.vue')
          },
          {
            path: '/reader-order-month',
            name: '会员包月订单',
            component: () => import('../components/reader/order-month.vue')
          },
          {
            path: '/reader-sta-order',
            name: '阅读订单统计',
            component: () => import('../components/reader/sta-order.vue')
          },
          {
            path: '/reader-sta-order-month',
            name: '包月订单统计',
            component: () => import('../components/reader/sta-order-month.vue')
          }],
        meta: {}
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/reader.js